/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
document.addEventListener('DOMContentLoaded', function () {
  if (typeof startDate !== 'undefined') {
    var countDownDate = new Date(startDate).getTime();
    var x = setInterval(function () {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hour = Math.floor(distance / (1000 * 60 * 60));
      var hours = hour < 10 ? '0' + hour : hour;
      var minute = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var minutes = minute < 10 ? '0' + minute : minute;
      var second = Math.floor((distance % (1000 * 60)) / 1000);
      var seconds = second < 10 ? '0' + second : second;
      document.getElementById('countdown').innerHTML =
        hours + ' : ' + minutes + ' : ' + seconds;
      if (distance < 0) {
        clearInterval(x);
        document.getElementById('countdown').innerHTML = 'EXPIRED';
      }
    }, 1000);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Define a function to be executed when the query changes
  function handleQueryChange() {
    // Your code to be executed when the query changes
    console.log('Query has changed:', window.location.search);
    // Add your custom logic here
  }

  // Attach the event listener to the popstate event
  window.onpopstate = function (event) {
    // Call the function when the popstate event occurs (e.g., back/forward button)
    handleQueryChange();
  };

  // Call the function on initial page load
  handleQueryChange();
});

function closeOpenDrawers() {
  const openDrawers = document.querySelectorAll('quick-buy-drawer[open]');
  openDrawers.forEach((drawer) => {
    drawer.removeAttribute('open');
  });
}

/** 
document.addEventListener('variant:loaded', function(event) {
  console.log("event:" + event.detail.variant.id);
  for (var i = 0; i <= productsCount; i++) {
  let loadedVariant = document.getElementById("product-json-" + i).innerHTML;
  let loadedVariantJson = JSON.parse(loadedVariant);
  var handleFound = false;
  for (var p = 0; p < loadedVariantJson.length; p++) {
    if ((loadedVariantJson[p]["option2"] === event.detail.variant.option2) && (loadedVariantJson[p]["option3"] === event.detail.variant.option3)) {
    handleFound = true;
    } 
  }
  if (!handleFound) {
  const childElement = document.getElementById("product-url-" + i);
  if (childElement) {
  const parentElement = childElement.closest('.color-swatch');
  parentElement.classList.add("is-disabled");
  const motherElement = childElement.closest('.variant-swatch');
  motherElement.style.display = 'none';
  }
  }
    };  
});

document.addEventListener('variant:changed', function(event) {
  console.log(event.detail.variant.id);
  var onStock = customData[event.detail.variant.id].available;
  const swatches = document.querySelectorAll(".color-swatch");
  for (let i = 0; i < swatches.length; i++) {
  swatches[i].classList.remove("is-disabled");
  };
  const variantSwatches = document.querySelectorAll(".variant-swatch");
  for (let i = 0; i < swatches.length; i++) {
  variantSwatches[i].style.display = 'block';
  };
  for (var i = 0; i <= productsCount; i++) {
  let newProduct = document.getElementById("product-json-" + i).innerHTML;
  var Url = document.getElementById("product-url-" + i)
  var Href = Url.href;
  var setUrl =  Href.split('?')
  let newProductJson = JSON.parse(newProduct);
  var selectedVariant = event.detail.variant;
  var handleFound = false;
  for (var p = 0; p < newProductJson.length; p++) {
    if ((newProductJson[p]["option2"] === event.detail.variant.option2) && (newProductJson[p]["option3"] === event.detail.variant.option3)) {
    var new_handle = ("?variant=" + newProductJson[p]["id"]);
    var oldUrl = setUrl[0];
    var newUrl = oldUrl + new_handle;
    document.getElementById("product-url-" + i).href = newUrl; 
    handleFound = true;
    } 
  }
if (!handleFound) {
  const childElement = document.getElementById("product-url-" + i);
  if (childElement) {
  const parentElement = childElement.closest('.color-swatch');
  parentElement.classList.toggle('is-disabled');
  const motherElement = childElement.closest('.variant-swatch');
  motherElement.style.display = 'none';
  }
} 
    }; 
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let variant_id = event.detail.variant.id;
    document.getElementById("AddToCart").onclick = function() { addAllToCart(variant_id);};
  });
*/

/*function addAllToCart(id) {
  var id = document.getElementById('motherproduct').value;
  console.log(id);
  var id1 = customData[id].product1,
    id2 = customData[id].product2,
    id3 = customData[id].product3,
    id4 = customData[id].product4,
    stock = customData[id].stock;

  if (stock !== false) {
    var xhr = new XMLHttpRequest();

    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        var xhr2 = new XMLHttpRequest();
        xhr2.open('POST', '/cart/add.js', true);
        xhr2.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded'
        );
        xhr2.onreadystatechange = function () {
          if (xhr2.readyState === XMLHttpRequest.DONE && xhr2.status === 200) {
            if (id3 !== 'X') {
              var xhr3 = new XMLHttpRequest();
              xhr3.open('POST', '/cart/add.js', true);
              xhr3.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded'
              );
              xhr3.onreadystatechange = function () {
                if (
                  xhr3.readyState === XMLHttpRequest.DONE &&
                  xhr3.status === 200
                ) {
                  if (id4 !== 'X') {
                    var xhr4 = new XMLHttpRequest();
                    xhr4.open('POST', '/cart/add.js', true);
                    xhr4.setRequestHeader(
                      'Content-Type',
                      'application/x-www-form-urlencoded'
                    );
                    xhr4.onreadystatechange = function () {
                      if (
                        xhr4.readyState === XMLHttpRequest.DONE &&
                        xhr4.status === 200
                      ) {
                        handleCartUpdate();
                      }
                    };
                    xhr4.send('quantity=1&id=' + id4);
                  } else {
                    handleCartUpdate();
                  }
                }
              };
              xhr3.send('quantity=1&id=' + id3);
            } else {
              handleCartUpdate();
            }
          }
        };
        xhr2.send('quantity=1&id=' + id2);
      }
    };
    xhr.send('quantity=1&id=' + id1);
  }

  function handleCartUpdate() {
    // Code to handle the cart update
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
      })
    );
    document.getElementById('mini-cart').open = true;

    // Additional code for cart-related actions
    // ...
  }

  // Additional code outside the function
  // ...
}*/

function changeProductDrawer(quick_url) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', quick_url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = xhr.responseText;
      var parser = new DOMParser();
      var doc = parser.parseFromString(response, 'text/html');
      var content = doc.querySelector('.drawer__content');
      var drawer = document.getElementById('drawer');
      drawer.innerHTML = content.innerHTML;
    }
  };
  xhr.send();
}

function changeProductPopover(quick_url) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', quick_url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var response = xhr.responseText;
      var parser = new DOMParser();
      var doc = parser.parseFromString(response, 'text/html');
      var content = doc.querySelector('.popover__content');
      var popover = document.getElementById('popover');
      popover.innerHTML = content.innerHTML;
    }
  };
  xhr.send();
}

function setMasterDevice() {
  const selectElement = document.getElementById('selectMasterDevice');
  const selectedValue = selectElement.value;
  sessionStorage.setItem('selectedDevice', selectedValue);
  const phoneModel = decodeURIComponent(selectedValue.split('=')[1]).replace(
    /\+/g,
    ' '
  );
  // Get all the input checkboxes inside the given element
  const inputCheckboxes = document.querySelectorAll(
    '#facet-filter-filter\\.v\\.option\\.phone\\ model input[type="checkbox"]'
  );
  // Loop through each input checkbox and set the "checked" property to false
  inputCheckboxes.forEach((inputCheckbox) => {
    inputCheckbox.checked = false;
  });
  const inputElement = document.querySelector(`input[value="${phoneModel}"]`);
  if (inputElement) {
    inputElement.click();
  } else {
    console.log('Element not found:', `input[value="${phoneModel}"]`);
  }
  // Get the button element
  const closeButton = document.querySelector('.modal__close-button');
  // Wait for 1 second before closing the modal
  if (closeButton) {
    closeButton.click();
  } else {
    console.log('close button not found');
  }
}

function setCollectionFilter() {
  const selectedValue = sessionStorage.getItem('selectedDevice');
  if (selectedValue) {
    const phoneModel = decodeURIComponent(selectedValue.split('=')[1]).replace(
      /\+/g,
      ' '
    );
    // Get all the input checkboxes inside the given element
    const inputCheckboxes = document.querySelectorAll(
      '#facet-filter-filter\\.v\\.option\\.phone\\ model input[type="checkbox"]'
    );
    // Loop through each input checkbox and set the "checked" property to false
    inputCheckboxes.forEach((inputCheckbox) => {
      inputCheckbox.checked = false;
    });
    const inputElement = document.querySelector(`input[value="${phoneModel}"]`);
    inputElement.click();
  }
}

function reloadContent(url) {
  var container = document.getElementById('ajax_replace');

  // Perform AJAX request
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      // Create a temporary container to hold the new content
      var tempContainer = document.createElement('div');
      tempContainer.innerHTML = xhr.responseText;

      // Find the desired content within the temporary container
      var newContent = tempContainer.querySelector('#ajax_replace').innerHTML;

      // Update the original container with the new content
      container.innerHTML = newContent;
    }
  };
  xhr.send();

  var container_2 = document.getElementById('ajax_replace_2');
  // Perform AJAX request
  var xhr_2 = new XMLHttpRequest();
  xhr_2.open('GET', url, true);
  xhr_2.onreadystatechange = function () {
    if (xhr_2.readyState === 4 && xhr_2.status === 200) {
      // Create a temporary container to hold the new content
      var tempContainer_2 = document.createElement('div');
      tempContainer_2.innerHTML = xhr_2.responseText;

      // Find the desired content within the temporary container
      var newContent_2 =
        tempContainer_2.querySelector('#ajax_replace_2').innerHTML;

      // Update the original container with the new content
      container_2.innerHTML = newContent_2;
    }
  };
  xhr_2.send();
}
